<template>
    <ks-dialog :title="props.title" v-model="disposalDialogVisible">
        <div class="dialog-content">
            <div class="dialog-msg">{{ props.content }}</div>
            <div class="dialog-footer">
                <div></div>
                <div>
                    <ks-button type="primary" @click="clickBind">我知道了</ks-button>
                </div>
            </div>
        </div>
    </ks-dialog>
</template>

<script setup lang="ts">
import { ref } from "vue";

const props = defineProps({
    id: {
        type: Number,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    content: {
        type: String,
        required: true,
    },
});

const showDialog = () => {
    disposalDialogVisible.value = true;
};

// 提交绑定结果
const clickBind = () => {
    disposalDialogVisible.value = false;
};

const disposalDialogVisible = ref(true);

defineExpose({
    showDialog,
});
</script>

<style lang="scss" scoped>
.dialog-content {
    padding: 24px 0;
}

.dialog-msg {
    color: #575859;
    font-size: 14px;
    line-height: 22px;
    word-break: break-word;
}

.dialog-footer {
    margin-top: 48px;
    margin-bottom: -24px;
    display: flex;
    justify-content: space-between;

    :deep(.ks-button) {
        width: 100px;
        height: 32px;
        line-height: 22px;
    }
}
</style>
